import { Component } from '@angular/core';

@Component({
  selector: 'vt-welcome-page',
  templateUrl: './welcome-page.component.html',
  styles: [],
})
export class WelcomePageComponent {
}
